import React, { lazy, Suspense, useState, useEffect } from 'react';
import { createBrowserHistory } from 'history';
import './App.css';
import Navbar from "./components/navbar/Navbar"
import CookieConsent from 'react-cookie-consent';
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom"
import { Route, Routes } from 'react-router-dom';
import initGA, { trackPageView } from './initGA';
import Wartungsseite from './pages/wartungsseite/Wartungsseite';
import NotFound from './pages/notfound/NotFound';

const Home = lazy(() => import("./pages/home/Home"))
const Seminar = lazy(() => import("./pages/seminar/Seminar"))
const Kontakt = lazy(() => import("./pages/Kontakt/Kontakt"))
const Themengebiete = lazy(() => import("./pages/themengebiete/Themengebiete"))
const AboutUs = lazy(() => import("./pages/aboutus/AboutUs"))
const Leistungen = lazy(() => import("./pages/leistungen/Leistungen"))
const Impressum = lazy(() => import("./pages/impressum/Impressum"))
const Datenschutz = lazy(() => import("./pages/datenschutz/Datenschutz"))

const Umsatzsteuerrecht = lazy(() => import("./pages/schulungen/RechtDatenschutz/Umsatzsteuerrecht"))
const Bilanzsteuerrecht = lazy(() => import("./pages/schulungen/RechtDatenschutz/Bilanzsteuerrecht"))
const Compliance = lazy(() => import("./pages/schulungen/RechtDatenschutz/Compliance"))
const StrategischesDenkenPerformance = lazy(() => import("./pages/schulungen/persoenlicheEntwicklung/StrategischesDenkenPerformance"))
const AgilitätScrum = lazy(() => import("./pages/schulungen/persoenlicheEntwicklung/AgilitätScrum"))
const StrategischZumErfolgmitOKR = lazy(() => import("./pages/schulungen/persoenlicheEntwicklung/StrategischZumErfolgmitOKR"))

const EmployerBrandingTopic = lazy(() => import("./pages/schulungen/personalwesen/EmployerBrandingTopic"))
const DigitaleTransformation = lazy(() => import("./pages/schulungen/personalwesen/DigitaleTransformationTopic"))
const Payroll = lazy(() => import("./pages/schulungen/personalwesen/PayrollTopic"))
const Talentmanagement = lazy(() => import("./pages/schulungen/personalwesen/TalentmanagementTopic"))
const HrControlling = lazy(() => import("./pages/schulungen/personalwesen/HrControllingTopic"))
const HrStrategie = lazy(() => import("./pages/schulungen/personalwesen/HrStrategieTopic"))

const CyberSecurity = lazy(() => import("./pages/schulungen/technology/CyberSecurityTopic"))
const DatenDynamik = lazy(() => import("./pages/schulungen/technology/DatenDynamikTopic"))
const MicroServices = lazy(() => import("./pages/schulungen/technology/MicroServices"))
const MicroFrontends = lazy(() => import("./pages/schulungen/technology/MicroFrontends"))

const GreenArchitecture = lazy(() => import("./pages/schulungen/architecture/GreenArchitectureTopic"))
const Logistikpower = lazy(() => import("./pages/schulungen/bauwesen/LogistikpowerTopic"))
const Waehrungsrisiken = lazy(() => import("./pages/schulungen/finance/WaehrungsrisikenTopic"))
const WinWinStrategien = lazy(() => import("./pages/schulungen/marketingAndCommunication/WinWinStrategienTopic"))
const HighPerformance = lazy(() => import("./pages/schulungen/persoenlicheEntwicklung/HighPerformanceTopic"))
const PraezisionImMaschinenbau = lazy(() => import("./pages/schulungen/maschinenbau/PraezisionImMaschinenbauTopic"))

function App() {
  const customHistory = createBrowserHistory();
  const [gaInitialized, setGaInitialized] = useState(false);

  const handleAcceptCookies = () => {
    if (!gaInitialized) {
      initGA();
      setGaInitialized(true);
    }
  };

  const [isIpad, setIsIpad] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      // Überprüfe, ob die Bildschirmbreite kleiner als eine bestimmte Breite ist (z.B. 768px)
      if (window.innerWidth >= 450 && window.innerWidth <= 1160) {
        setIsIpad(true);  // Wartungsseite anzeigen (iPad-Resolution)
    } else {
        setIsIpad(false);  // Normale Seite anzeigen (alles unter 600px und über 1160px)
    }
    };

    checkScreenSize();
    // Event Listener für die Bildschirmgröße hinzufügen
    window.addEventListener('resize', checkScreenSize);

    // Event Listener beim Verlassen der Komponente entfernen
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);


  useEffect(() => {
    // Überprüfen, ob der Benutzer bereits der Verwendung von Cookies zugestimmt hat
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'true') {
      handleAcceptCookies();
    }
  }, []);

  useEffect(() => {
    if (gaInitialized) {
      // Lausche auf Route-Änderungen
      const unlisten = customHistory.listen((location) => {
        trackPageView(location.pathname + location.search); // Tracke die neue Route
        console.log(location.pathname + location.search)
      });
      // Cleanup-Funktion
      return () => {
        unlisten();
      };
    }
  }, [gaInitialized]);


  if (isIpad) {
    return <Wartungsseite />;
  }

  return (
    <React.Fragment>
    <Router>
      <CookieConsent
        onAccept={() => {
          localStorage.setItem('cookieConsent', 'true');
          handleAcceptCookies();
        }}
        containerClasses='containerCookieClass'
        buttonText="Zustimmen"
        buttonClasses="buttonCookie"
        buttonWrapperClasses="buttonCookieWrapper"
        declineButtonClasses="declineButtonCookie"
        declineButtonText="Ablehnen"
        enableDeclineButton
        style={{paddingTop: '10px'}}
        buttonStyle={{ background: "#ffa500", fontWeight: "400", color: "white"}}
        onDecline={() => localStorage.setItem('cookieConsent', 'false')}
      >
        Diese Website verwendet Cookies, um die Benutzererfahrung zu verbessern. Durch die Nutzung unserer Website stimmen Sie unserer <span> </span>
        <Link to="/datenschutz" target="_blank" className='link-cookies'>Cookie-Policy</Link>
        <span> </span>zu.
      </CookieConsent>
      <Navbar />
        <Suspense fallback={<Loading />}>
          <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/seminar" element={<Seminar />} />
              <Route path="/kontaktiere-uns"  element={<Kontakt />} />
              <Route path="/themengebiete"  element={<Themengebiete />} />
              <Route path="/ueber-uns"  element={<AboutUs />} />
              <Route path="/leistungen"  element={<Leistungen />} />
              <Route path="/impressum"  element={<Impressum />} />
              <Route path="/datenschutz"  element={<Datenschutz />} />
              
              <Route path="/employer-branding"  element={<EmployerBrandingTopic />} />
              <Route path="/digitale-transformation-im-hr"  element={<DigitaleTransformation />} />
              <Route path="/talentmanagement-und-nachfolgeplanung"  element={<Talentmanagement />} />
              <Route path="/hr-controlling-und-datenanalyse"  element={<HrControlling />} />
              <Route path="/grundlagen-der-entgeltabrechnung"  element={<Payroll />} />
              <Route path="/hr-strategie-und-personalmanagement"  element={<HrStrategie />} />

              <Route path="/cyber-security"  element={<CyberSecurity />} />
              <Route path="/daten-dynamik"  element={<DatenDynamik />} />
              <Route path="/micro-services"  element={<MicroServices />} />
              <Route path="/micro-frontends"  element={<MicroFrontends />} />

              <Route path="/logistikpower-am-bau"  element={<Logistikpower />} />
              <Route path="/waehrungsrisiken-meistern"  element={<Waehrungsrisiken />} />
              <Route path="/praezision-im-maschinenbau"  element={<PraezisionImMaschinenbau />} />
              <Route path="/win-win-strategien"  element={<WinWinStrategien />} />
              <Route path="/high-performance-fit-durchs-berufsleben"  element={<HighPerformance />} />
              <Route path="/green-architecture-entdecken"  element={<GreenArchitecture />} />
							
							<Route path="/umsatzsteuerrecht"  element={<Umsatzsteuerrecht />} />
							<Route path="/bilanzsteuerrecht"  element={<Bilanzsteuerrecht />} />
							<Route path="/compliance"  element={<Compliance />} />
							<Route path="/strategisch-zum-erfolg-mit-okr"  element={<StrategischZumErfolgmitOKR />} />
							<Route path="/agilitaet"  element={<AgilitätScrum />} />
							<Route path="/strategisches-denken"  element={<StrategischesDenkenPerformance />} />
              
              <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
    </Router>
    </React.Fragment>
  );
}


const Loading = () => {
  return (
  <div className='loader'>
      <ul>
        <li></li>
        <li></li>
        <li></li>
      </ul>
  </div>
  )
};

export default App;
